<script>
    import { link } from "svelte-routing";
</script>


<a use:link href="/passwort/reset">Passwort vergessen?</a>